import * as React from "react";
function LocationHomeIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M19.5 10.101c-.02 2.535-.902 4.6-2.883 5.94-1.525 1.03-2.522 2.366-3.346 3.931-.233.441-.374 1.047-1.057 1.028-.632-.02-.738-.61-.994-1.018-.257-.408-.51-.868-.746-1.31a6 6 0 00-2.07-2.232c-2.52-1.646-3.665-4.015-3.354-6.989.453-4.321 4.539-7.162 8.584-6.295 3.095.662 4.992 2.624 5.72 5.705.077.41.125.824.146 1.24zm-7.254 10.13c.415-.727.771-1.323 1.103-1.939.575-1.059 1.389-1.873 2.396-2.543 2.14-1.425 3.17-3.45 2.939-6.034-.238-2.667-1.662-4.539-4.123-5.497-2.462-.959-4.803-.498-6.735 1.324-3.101 2.912-2.688 7.743.838 10.14a7.896 7.896 0 012.657 2.912c.267.516.572 1.015.925 1.638z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.518 13c-.168 0-.304-.122-.304-.271V9.417l-.714.54a.329.329 0 01-.428-.033.251.251 0 01.035-.381l3.947-2.98a.326.326 0 01.196-.063c.072 0 .141.022.196.064l3.946 2.979a.252.252 0 01.036.382.32.32 0 01-.232.096.326.326 0 01-.195-.064l-.715-.54v3.312c0 .15-.136.27-.303.27H9.518zm5.161-.542v-3.5L12.25 7.125 9.822 8.958v3.5h1.214v-1.355c0-.597.545-1.083 1.214-1.083.67 0 1.215.486 1.215 1.083v1.355h1.214zm-1.822 0v-1.355c0-.299-.271-.542-.607-.542-.335 0-.607.243-.607.542v1.354h1.214z"
  }));
}
const ForwardRef = React.forwardRef(LocationHomeIcon);
export default ForwardRef;